import styled from "styled-components";

type ButtonProps = {
	darkMode: "dark" | "light";
};

export const StyledDarkMode = styled.button<ButtonProps>`
	position: fixed;
	z-index: 1006;
	bottom: 20px;
	left: 20px;
	border: none;
	background-color: white;
	border-radius: 100%;
	width: 60px;
	height: 60px;
	transition: 0.5s;
	padding-left: ${(props) => (props.darkMode === "dark" ? "6px" : "8px")};
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${(props) =>
		props.darkMode === "dark" ? "var(--darkBlue)" : "#F4AC1C"};
	font-size: 30px;
	border: 2px solid
		${(props) => (props.darkMode === "dark" ? "var(--darkBlue)" : "#F4AC1C")};
	&:hover {
		filter: brightness(120%);
	}
`;
